import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import BackgroundElements from './background-elements/BackgroundElements';

const AnimatedPackContainer = ({ title, subtitle, imgSrc, imgAlt, style }) => {
  const [isOpened, setIsOpened] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsOpened(entry.isIntersecting);
      },
      {
        threshold: 1.0
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.packContainer} style={style}>
      <p>{title}</p>
      <p className={styles.subtitle}>{subtitle}</p>
      <img
        ref={imgRef}
        className={isOpened ? styles.opened : ''}
        src={imgSrc}
        alt={imgAlt}
      />
    </div>
  );
};

const HomeScreen = () => {
  const packsRef = useRef(null);

  const scrollToPacks = () => {
    packsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.content}
        style={{
          backgroundImage: `url(${getImageFromS3('images/sms-prlm-s/bg.png')})`
        }}
      >
        <BackgroundElements />
        <div className={styles.header}>
          <img src={getImageFromS3('images/sms-prlm-s/logo.png')} alt="logo" />
        </div>
        <div className={styles.videoContainer}>
          <video
            src={getImageFromS3('images/sms-prlm-s/video.mp4')}
            autoPlay
            loop
            muted
            playsInline
            style={{ marginTop: 10, width: '100%', borderRadius: '20px' }}
          />
          <button onClick={scrollToPacks}>
            <img
              src={getImageFromS3('images/sms-prlm-s/button.png')}
              alt="button"
            />
            <p>До продукту</p>
          </button>
        </div>
        <div className={styles.packsContainer} ref={packsRef}>
          <div className={styles.packItem}>
            <img
              src={getImageFromS3('images/sms-prlm-s/gold.png')}
              alt="gold"
            />
            <div className={styles.titleContainer}>
              <p className={styles.signature}>Signature</p>
              <p className={styles.title}>gold</p>
              <p className={styles.characteristic}>Вміст смол – 4 мг</p>
            </div>
          </div>
          <div className={styles.packItem}>
            <img
              src={getImageFromS3('images/sms-prlm-s/bronze.png')}
              alt="bronze"
            />
            <div className={styles.titleContainer}>
              <p className={styles.signature}>Signature</p>
              <p className={styles.title}>bronze</p>
              <p className={styles.characteristic}>Вміст смол – 6 мг</p>
            </div>
          </div>
        </div>
        <AnimatedPackContainer
          title="Smart Seal"
          subtitle={
            <>
              захисний елемент упаковки, що
              <br />
              допомагає довше зберігати свіжість та
              <br />
              смакові властивості тютюнової суміші
            </>
          }
          imgSrc={getImageFromS3('images/sms-prlm-s/pack.png')}
          imgAlt="pack"
          style={{ marginTop: 115 }}
        />
        <AnimatedPackContainer
          title="Recessed filter"
          subtitle={
            <>
              Фільтр з повітряною камерою
              <br />у чорному дизайні
            </>
          }
          imgSrc={getImageFromS3('images/sms-prlm-s/filter.png')}
          imgAlt="filter"
        />
        <AnimatedPackContainer
          title="Нова"
          subtitle={
            <>
              ексклюзивна тютюнова суміш
              <br />
              від Parliament
            </>
          }
          imgSrc={getImageFromS3('images/sms-prlm-s/tobacco.png')}
          imgAlt="tobacco"
        />
        <AnimatedPackContainer
          title="«Кінг Сайз» Стандарт"
          subtitle="формат"
          imgSrc={getImageFromS3('images/sms-prlm-s/format.png')}
          imgAlt="format"
        />
        <div className={styles.buttonContainer}>
          <p className={styles.buttonTitle}>Актуальний асортимент</p>
          <p className={styles.buttonDescription}>
            можна знайти у роздрібних точках продажу в твоєму місті або
            <br /> на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonList}>
            <a
              href="https://cig-poshta.in.ua/product-tag/signature/?utm_source=CDAsms_Signature"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.button}
            >
              <img
                src={getImageFromS3('images/sms-prlm-s/small-button.png')}
                alt="glass-button"
              />
              <p>Cig-Poshta</p>
            </a>
            <a
              href="https://rozetka.com.ua/ua/sigareti/c4638591/price=2200-2200;producer=parliament/?utm_source=PMUsms_Signature"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.button}
            >
              <img
                src={getImageFromS3('images/sms-prlm-s/small-button.png')}
                alt="glass-button"
              />
              <p>Rozetka</p>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає
        <br />
        серйозні
        <br />
        захворювання та
        <br />
        залежність
        <br />
        Дана інформація
        <br />
        про продукт
        <br /> відповідно
        <br /> надається
        <br /> до статті 15 Закону
        <br /> України «Про захист
        <br />
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки
        <br /> залишав(-ла) запит на отримання
        <br />
        інформації про продукцію компаній Philip
        <br /> Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-prlm-s">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
